import type { ProductDetailsSticksData } from "@jti/fe-common";

import type { FallbackProductsSkus } from "@product-details/containers/SticksProductDetailsContainer/types";

export const getFallbackProductSkus = (sticksData: ProductDetailsSticksData): FallbackProductsSkus => {
  const [mix_n_match_onetime] = sticksData.mix_n_match.onetime;
  const [mix_n_match_subscription] = sticksData.mix_n_match.subscription;
  const [defaultCartonOnetime] = sticksData.cartons.onetime;
  const [defaultCartonSubscription] = sticksData.cartons.subscription;
  const [defaultSinglePackOnetime] = sticksData.single_packs.onetime;

  return {
    onetime: {
      single_packs: defaultSinglePackOnetime?.sku,
      cartons: defaultCartonOnetime?.sku,
      mix_n_match: mix_n_match_onetime?.sku,
    },
    subscription: {
      cartons: defaultCartonSubscription?.sku,
      mix_n_match: mix_n_match_subscription?.sku,
    },
  };
};
